import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  switch(e) {
    const sidepanelId = e.detail.sidepanelId;
    const isActive = e.detail.active;

    this.active = this.element.id === sidepanelId && isActive;
  }

  set active(value) {
    this.element.classList.toggle('-z-1', this.active && !value);
    this.element.classList.toggle('is-active', value);
  }

  get active() {
    return this.element.classList.contains('is-active');
  }
}
